//The contents of this file have been generated automatically. Do not edit this file.

import * as t from 'io-ts';
import { isRight } from 'fp-ts/lib/Either';
import { fetchGeneralRaw, FetchGeneralRawResponseType } from 'src_common/common/fetch';
import { ApiTimeLog } from 'src_common/server/webDriver/logFormat';


export interface ParamsType {
    user_id: number;
    requestBody: {
        balanceDeltaSign?: null | undefined | number;
        endDate?: null | undefined | string;
        sort?: null | undefined | string;
        startDate?: null | undefined | string;
        transactionStatus?: null | undefined | string;
        transactionTypes?: null | undefined | Array<string>;
    };
}


const createGuard = <A>(code: number, decoder: t.Type<A, A, unknown>): ((data: unknown) => A) => {
    return (data: unknown): A => {
        const decodeResult = decoder.decode(data);
        if (isRight(decodeResult)) {
            return decodeResult.right;
        }
        throw Error(`Response decoding error /api-proxy/staff/asset-flows-csv/{user_id} -> post -> ${code}`);
    };
};

export const Response200IO = t.array(t.interface({
    balanceAfter: t.string,
    balanceDelta: t.string,
    currency: t.string,
    date: t.string,
    description: t.union([t.null, t.undefined, t.string]),
    finalizedAt: t.union([t.null, t.undefined, t.string]),
    freebetCredits: t.array(t.interface({
        amount: t.number,
        id: t.number,
    })),
    gameName: t.union([t.null, t.undefined, t.string]),
    id: t.number,
    paymentMethod: t.union([t.null, t.undefined, t.interface({
        type: t.string,
    })]),
    paymentResponse: t.union([t.null, t.undefined, t.interface({
        providerOrderId: t.string,
    })]),
    status: t.string,
    transactionId: t.number,
    type: t.string,
}));
export type Response200Type = Array<{
    balanceAfter: string;
    balanceDelta: string;
    currency: string;
    date: string;
    description?: null | undefined | string;
    finalizedAt?: null | undefined | string;
    freebetCredits: Array<{
        amount: number;
        id: number;
    }>;
    gameName?: null | undefined | string;
    id: number;
    paymentMethod?: null | undefined | {
        type: string;
    };
    paymentResponse?: null | undefined | {
        providerOrderId: string;
    };
    status: string;
    transactionId: number;
    type: string;
}>;
export const decodeResponse200 = createGuard(200, Response200IO);

export const Response400IO = t.string;
export type Response400Type = string;
export const decodeResponse400 = createGuard(400, Response400IO);

export const Response401IO = t.string;
export type Response401Type = string;
export const decodeResponse401 = createGuard(401, Response401IO);

export const Response500IO = t.string;
export type Response500Type = string;
export const decodeResponse500 = createGuard(500, Response500IO);



type ExtraHeadersType = Record<string, string>


/**
 * @deprecated - Please use this method "openapiProxyStaffAssetFlowsCsvRequest"
 */
export const openapi_proxy_staff_asset_flows_csv = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<FetchGeneralRawResponseType> => {
    
        
    const query = '';
    const url = `${api_url}/api-proxy/staff/asset-flows-csv/${params.user_id}${query}`;
    
    const method = 'POST';
    const paramsFetch = {
        url,
        body: params.requestBody,
        backendToken,
        timeout: api_timeout,
        extraHeaders,
    };

    const apiTime = ApiTimeLog.createWithProcessEnv(method, url);
    const response = await fetchGeneralRaw(method, paramsFetch);
    apiTime.show(response.status);
    return response;
};


export type OpenapiProxyStaffAssetFlowsCsvParamsType = ParamsType;

export type OpenapiProxyStaffAssetFlowsCsvResponseType = {
    status: 200;
    body: Response200Type;
} | {
    status: 400;
    body: Response400Type;
} | {
    status: 401;
    body: Response401Type;
} | {
    status: 500;
    body: Response500Type;
};

export type OpenapiProxyStaffAssetFlowsCsvResponse200Type = Response200Type;

export const openapiProxyStaffAssetFlowsCsvRequest = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<OpenapiProxyStaffAssetFlowsCsvResponseType> => {
    const response = await openapi_proxy_staff_asset_flows_csv(api_url, api_timeout, backendToken, params, extraHeaders);
    const { status, body } = response;

    let json = null;

    try {
        json = JSON.parse(body);
    } catch (_err) {
        console.warn(`Http status ${status} - json was expected`);
        json = {};
    }
    
    if (status === 200) {
        return { status: 200, body: decodeResponse200(json) };
    }

    if (status === 400) {
        return { status: 400, body: decodeResponse400(json) };
    }

    if (status === 401) {
        return { status: 401, body: decodeResponse401(json) };
    }

    if (status === 500) {
        return { status: 500, body: decodeResponse500(json) };
    }

    throw new Error(`openapiProxyStaffAssetFlowsCsvRequest - unhandled response ${response.status}`);
};

